import { LIST_GC_TIME_MS, LIST_STALE_TIME_MS, useApiClient } from '@klareospace/pharos-lib-front-utils';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { createOrdersApi, orderKeys } from '../api';
import type { OrderSearchResult, SearchOrdersParams } from '../api';

// ─── Hook ─────────────────────────────────────────────────────────────────────

export function useOrders(queryParams: SearchOrdersParams): UseQueryResult<OrderSearchResult> {
  const client = useApiClient('deliveries');
  const api = createOrdersApi(client);

  return useQuery({
    gcTime: LIST_GC_TIME_MS,
    queryFn: () => api.searchOrders(queryParams),
    queryKey: orderKeys.list(queryParams),
    staleTime: LIST_STALE_TIME_MS,
  });
}
